import React from 'react';
import { emptyParty } from './data/mockData';

const PartyForm = ({ party, onChange, onSave, onCancel, isEditing, isCreating, setIsEditing, title }) => {
  if (!party) return null;
  return (
    <div className={`p-4 border rounded-lg space-y-3 ${isEditing ? 'border-blue-200 bg-blue-50' : 'border-green-200 bg-green-50'}`}>
      <div className="flex justify-between items-center">
        <h3 className="font-semibold text-lg text-gray-800">{title}</h3>
        {!isEditing && party && (<button onClick={() => setIsEditing(true)} className="text-sm bg-blue-500 text-white py-1 px-3 rounded-md hover:bg-blue-600">Edit</button>)}
      </div>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-x-6 gap-y-3 text-sm">
        {Object.keys(emptyParty).map(key => (
          <div key={key} className={key === 'Address' ? 'md:col-span-3' : ''}>
            <label className="block text-xs font-medium text-gray-600 mb-1">{key}</label>
            {isEditing ? (
              <input type={key === 'PId' ? 'number' : 'text'} name={key} value={party[key]} onChange={onChange} disabled={key === 'PId' && !isCreating} className="w-full p-2 border border-gray-300 rounded-md shadow-sm" />
            ) : (<p className="p-2 bg-white rounded-md h-9 flex items-center">{party[key]}</p>)}
          </div>
        ))}
      </div>
      {isEditing && (
        <div className="flex justify-end space-x-3 pt-2">
          <button onClick={onCancel} className="px-4 py-2 bg-gray-300 text-gray-800 font-semibold rounded-md hover:bg-gray-400">Cancel</button>
          <button onClick={onSave} className="px-4 py-2 bg-green-600 text-white font-semibold rounded-md hover:bg-green-700">Save</button>
        </div>
      )}
    </div>
  );
};



export default PartyForm;
